import { storage } from './storage.js';

/* Modo desarrollador: herramientas solo para quien administra Filoteca (p. ej. descargar la configuración completa en JSON).
   Se activa a mano pulsando 7 veces seguidas la versión en Ajustes → Acerca de (en cualquier versión de la app) y se apaga desde
   el mismo sitio: depende solo de ese interruptor (ser administrador de la web no lo enciende). No cambia nada para el resto. */

const KEY = 'devMode';
const TAPS = 7;
const WINDOW_MS = 2500;
let taps = [];

export const devMode = {
    on() {
        return this.manual();
    },
    /** ¿Está activado? (Se mantiene `manual()` por claridad en quien lo llama.) */
    manual() {
        return !!storage.get(KEY, false);
    },
    set(v) {
        if (v) storage.set(KEY, true); else storage.remove(KEY);
        taps = [];
    },
    /** Una pulsación sobre la versión. → { unlocked, left } (left = las que faltan). */
    tap(now = Date.now()) {
        if (this.manual()) return { unlocked: false, left: 0, already: true };
        taps = taps.filter((x) => now - x < WINDOW_MS);
        taps.push(now);
        if (taps.length >= TAPS) { this.set(true); return { unlocked: true, left: 0 }; }
        return { unlocked: false, left: TAPS - taps.length };
    }
};
